/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global Reflect, Promise, SuppressedError, Symbol */
var extendStatics = function (d, b) {
  extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
  };

  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function () {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];

      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;

        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };

        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;

        case 7:
          op = _.ops.pop();

          _.trys.pop();

          continue;

        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }

          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }

          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }

          if (t && _.label < t[2]) {
            _.label = t[2];

            _.ops.push(op);

            break;
          }

          if (t[2]) _.ops.pop();

          _.trys.pop();

          continue;
      }

      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var FREEZE_CACHE_DELETION_TYPE;
(function (FREEZE_CACHE_DELETION_TYPE) {
    FREEZE_CACHE_DELETION_TYPE["ALL"] = "all";
    FREEZE_CACHE_DELETION_TYPE["MANUAL"] = "manual";
    FREEZE_CACHE_DELETION_TYPE["TTL"] = "ttl";
})(FREEZE_CACHE_DELETION_TYPE || (FREEZE_CACHE_DELETION_TYPE = {}));
var Cache = /** @class */ (function () {
    function Cache() {
        this.cache = new Map();
        this.maxCache = 20;
        this.timer = {};
        this.freezedCacheDeletion = {};
    }
    Cache.prototype.get = function (cacheKey) {
        return this.cache.get(cacheKey);
    };
    Cache.prototype.set = function (cacheKey, value, ttl) {
        var _this = this;
        if (ttl === void 0) { ttl = 60000; }
        // 如果超过最大缓存数, 删除头部的第一个缓存.
        if (this.maxCache > 0 && this.cache.size >= this.maxCache) {
            // @ts-ignore: ignore ts --downlevelIteration
            var deleteKey = __spreadArray([], this.cache.keys(), true)[0];
            this.cache.delete(deleteKey);
            if (this.timer[deleteKey]) {
                clearTimeout(this.timer[deleteKey]);
            }
        }
        this.cache.set(cacheKey, value);
        if (ttl > 0) {
            this.timer[cacheKey] = setTimeout(function () {
                if (_this.allowDeleteCacheEntry(cacheKey, FREEZE_CACHE_DELETION_TYPE.TTL)) {
                    _this.cache.delete(cacheKey);
                    delete _this.timer[cacheKey];
                }
            }, ttl);
        }
    };
    Cache.prototype.delete = function (cacheKey) {
        delete this.timer[cacheKey];
        return this.cache.delete(cacheKey);
    };
    Cache.prototype.clear = function () {
        var _this = this;
        Object.entries(this.timer).forEach(function (_a) {
            var timerKey = _a[0];
            if (_this.allowDeleteCacheEntry(timerKey, FREEZE_CACHE_DELETION_TYPE.MANUAL)) {
                delete _this.timer[timerKey];
            }
        });
        this.cache.forEach(function (value, timerKey) {
            if (_this.allowDeleteCacheEntry(timerKey, FREEZE_CACHE_DELETION_TYPE.MANUAL)) {
                _this.cache.delete(timerKey);
            }
        });
    };
    Cache.prototype.clearOneCache = function (cacheKey) {
        var _this = this;
        Object.entries(this.timer).forEach(function (_a) {
            var timerKey = _a[0];
            if (_this.allowDeleteCacheEntry(timerKey, FREEZE_CACHE_DELETION_TYPE.MANUAL) &&
                cacheKey === timerKey) {
                delete _this.timer[timerKey];
            }
        });
        this.cache.forEach(function (value, timerKey) {
            if (_this.allowDeleteCacheEntry(timerKey, FREEZE_CACHE_DELETION_TYPE.MANUAL) &&
                cacheKey === timerKey) {
                _this.cache.delete(timerKey);
            }
        });
    };
    Cache.prototype.freezeCacheDeletion = function (urlToFreeze) {
        if (urlToFreeze === void 0) { urlToFreeze = {}; }
        this.freezedCacheDeletion = __assign(__assign({}, this.freezedCacheDeletion), urlToFreeze);
    };
    Cache.prototype.allowDeleteCacheEntry = function (key, type) {
        return !Object.entries(this.freezedCacheDeletion).some(function (_a) {
            var freezedKey = _a[0], freezedType = _a[1];
            return (key.includes(freezedKey) &&
                (freezedType === FREEZE_CACHE_DELETION_TYPE.ALL ||
                    type === freezedType));
        });
    };
    return Cache;
}());

function compose(middlewares) {
    if (!Array.isArray(middlewares))
        throw new TypeError("Middlewares must be an array!");
    var middlewaresLen = middlewares.length;
    // eslint-disable-next-line no-plusplus
    for (var i = 0; i < middlewaresLen; i++) {
        if (typeof middlewares[i] !== "function") {
            throw new TypeError("Middleware must be composed of function");
        }
    }
    return function wrapMiddlewares(params, next) {
        var index = -1;
        function dispatch(i) {
            if (i <= index) {
                return Promise.reject(new Error("next() should not be called multiple times in one middleware!"));
            }
            index = i;
            var fn = middlewares[i] || next;
            if (!fn)
                return Promise.resolve();
            try {
                return Promise.resolve(fn(params, function () { return dispatch(i + 1); }));
            }
            catch (err) {
                return Promise.reject(err);
            }
        }
        return dispatch(0);
    };
}

var Onion = /** @class */ (function () {
    function Onion() {
        this.middlewares = [];
    }
    Onion.prototype.use = function (middleware) {
        if (typeof middleware !== "function")
            throw new TypeError("Middleware is not a function.");
        this.middlewares.push(middleware);
    };
    Onion.prototype.execute = function (params) {
        var fn = compose(__spreadArray([], this.middlewares, true));
        return fn(params);
    };
    return Onion;
}());

var RequestError = /** @class */ (function (_super) {
    __extends(RequestError, _super);
    function RequestError(text, request, type) {
        if (type === void 0) { type = "RequestError"; }
        var _this = _super.call(this, text) || this;
        _this.name = "RequestError";
        _this.request = request;
        _this.type = type;
        return _this;
    }
    return RequestError;
}(Error));
var ResponseError = /** @class */ (function (_super) {
    __extends(ResponseError, _super);
    function ResponseError(response, text, data, request, type) {
        if (type === void 0) { type = "ResponseError"; }
        var _this = _super.call(this, text || response.statusText) || this;
        _this.name = "ResponseError";
        _this.data = data;
        _this.response = response;
        _this.request = request;
        _this.type = type;
        return _this;
    }
    return ResponseError;
}(Error));

function timeout2Throw(msec, request, callback) {
    var timerId;
    return {
        promise: new Promise(function (_, reject) {
            timerId = setTimeout(function () {
                reject(new RequestError("timeout of ".concat(msec, "ms exceeded"), request, "Timeout"));
                callback();
            }, msec);
        }),
        timer: timerId,
    };
}
// Check env is browser or node
function getEnv() {
    var env;
    // Only Node.JS has a process variable that is of [[Class]] process
    if (typeof process !== "undefined" &&
        toString.call(process) === "[object process]") {
        // For node use HTTP adapter
        env = "NODE";
    }
    if (typeof XMLHttpRequest !== "undefined") {
        env = "BROWSER";
    }
    return env;
}
function clearCache(cache) {
    if (cache.clear)
        cache.clear();
}

var Deferred = /** @class */ (function () {
    function Deferred(handler) {
        var _this = this;
        this.resolve = function () { };
        this.reject = function () { };
        var promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
            if (handler)
                handler(resolve, reject);
        });
        promise.resolve = this.resolve;
        promise.reject = this.reject;
        return promise;
    }
    return Deferred;
}());

var canAbortFetch = false;
var forceCacheApis = ["/v2/private/user/profile"];
// Window cannot be used in web worker
try {
    canAbortFetch = "AbortController" in window;
}
catch (_) {
    canAbortFetch = false;
}
function processRequestInterceptors(ctx, interceptors) {
    return __awaiter(this, void 0, void 0, function () {
        var reducer;
        return __generator(this, function (_a) {
            reducer = function (p1, p2) {
                return p1.then(function (ret) {
                    if (ret === void 0) { ret = {}; }
                    ctx.req.url = ret.url || ctx.req.url;
                    ctx.req.options = ret.options || ctx.req.options;
                    return p2(ctx.req.url, ctx.req.options, ctx.operations);
                });
            };
            return [2 /*return*/, interceptors
                    .reduce(reducer, Promise.resolve())
                    .then(function (ret) {
                    if (ret === void 0) { ret = {}; }
                    ctx.req.url = ret.url || ctx.req.url;
                    ctx.req.options = ret.options || ctx.req.options;
                    return Promise.resolve(ctx);
                })];
        });
    });
}
// This interceptor might be dangerous, so we disabled for now for further discussion
function processGlobalRequestInterceptors(ctx) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // const matchedGlobalRequest = ctx?.interceptors?.globalRequestMap[ctx.req.url];
            // if (matchedGlobalRequest && Array.isArray(matchedGlobalRequest)) {
            //   return processRequestInterceptors(ctx, matchedGlobalRequest)
            // }
            return [2 /*return*/, Promise.resolve(ctx)];
        });
    });
}
function processInstanceRequestInterceptors(ctx) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var instanceRequest;
        return __generator(this, function (_b) {
            instanceRequest = (_a = ctx === null || ctx === void 0 ? void 0 : ctx.interceptors) === null || _a === void 0 ? void 0 : _a.instanceRequest;
            if (instanceRequest && Array.isArray(instanceRequest)) {
                return [2 /*return*/, processRequestInterceptors(ctx, instanceRequest)];
            }
            return [2 /*return*/, Promise.resolve(ctx)];
        });
    });
}
// runs synchronously and does not return anything
function processGlobalResponseInterceptors(res, ctx) {
    return __awaiter(this, void 0, void 0, function () {
        var matchedGlobalResponse, clonedRes_1;
        return __generator(this, function (_a) {
            matchedGlobalResponse = ctx.interceptors.globalResponseMap[ctx.req.url];
            if (matchedGlobalResponse && Array.isArray(matchedGlobalResponse)) {
                clonedRes_1 = getEnv() === "BROWSER" && typeof res.clone === "function"
                    ? res.clone()
                    : res;
                matchedGlobalResponse.forEach(function (handler) {
                    return handler(clonedRes_1, ctx.req.options, ctx.operations);
                });
            }
            return [2 /*return*/];
        });
    });
}
function processInstanceResponseInterceptors(res, ctx) {
    return __awaiter(this, void 0, void 0, function () {
        var response, responsePromise;
        return __generator(this, function (_a) {
            response = typeof res.clone === "function" ? res.clone() : res;
            responsePromise = Promise.resolve(response);
            ctx.interceptors.instanceResponse.forEach(function (handler) {
                responsePromise = responsePromise.then(function (res) {
                    var clonedRes = getEnv() === "BROWSER" && typeof res.clone === "function"
                        ? res.clone()
                        : res;
                    return handler(clonedRes, ctx.req.options, ctx.operations);
                });
            });
            return [2 /*return*/, responsePromise];
        });
    });
}
function fetchMiddleware(ctx, next) {
    var _this = this;
    var _a = ctx.req, url = _a.url, _b = _a.options, options = _b === void 0 ? {} : _b, cache = ctx.cache, cacheKey = ctx.cacheKey;
    ctx.operations.createRequestError = function (text) { return new RequestError(text, ctx.req); };
    var _c = options.useCache, useCache = _c === void 0 ? false : _c, _d = options.timeout, timeout = _d === void 0 ? 30000 : _d, _e = options.validateStatus, validateStatus = _e === void 0 ? function (status) { return status >= 200 && status < 300; } : _e, _f = options.ttl, ttl = _f === void 0 ? 60000 : _f;
    var cachePromise = cache.get(cacheKey);
    if (!cachePromise || !useCache) {
        cachePromise = new Deferred();
        if (useCache) {
            cache.set(cacheKey, cachePromise, ttl);
        }
        var promiseToReturn = processGlobalRequestInterceptors(ctx)
            .then(function (context) {
            return processInstanceRequestInterceptors(context);
        })
            .then(function (ctx) { return __awaiter(_this, void 0, void 0, function () {
            var hackedOpts, promiseToAbortController, fetchPromise, timeout2ThrowResult;
            return __generator(this, function (_a) {
                hackedOpts = ctx.req.options;
                if (canAbortFetch) {
                    promiseToAbortController = new AbortController();
                }
                fetchPromise = fetch(url, __assign(__assign({}, hackedOpts), { signal: promiseToAbortController
                        ? promiseToAbortController.signal
                        : undefined })).catch(function (err) {
                    cachePromise.reject(new RequestError((err === null || err === void 0 ? void 0 : err.message) || "Faild to fetch, http network error", ctx === null || ctx === void 0 ? void 0 : ctx.req));
                    throw new RequestError("http network error", ctx.req);
                });
                timeout2ThrowResult = timeout2Throw(timeout, ctx.req, function () {
                    if (canAbortFetch)
                        promiseToAbortController.abort();
                });
                return [2 /*return*/, (Promise.race([fetchPromise, timeout2ThrowResult.promise])
                        .then(function (res) {
                        var clonedRes = getEnv() === "BROWSER" && typeof res.clone === "function"
                            ? res.clone()
                            : res;
                        if (validateStatus(clonedRes.status) && useCache) {
                            clonedRes.useCache = true;
                            cachePromise.resolve(clonedRes);
                        }
                        return res;
                    })
                        // globally interceptors runs synchronously
                        .then(function (res) {
                        ctx.operations.createResponseError = function (text, data) {
                            return new ResponseError(res, text, data, ctx.req);
                        };
                        processGlobalResponseInterceptors(res, ctx);
                        return res;
                    })
                        // instance interceptors runs asynchronously
                        .then(function (res) {
                        return processInstanceResponseInterceptors(res, ctx);
                    })
                        .then(function (res) {
                        ctx.res = res;
                        return next();
                    })
                        .catch(function (err) {
                        if (forceCacheApis === null || forceCacheApis === void 0 ? void 0 : forceCacheApis.every(function (u) { var _a; return !((_a = ctx === null || ctx === void 0 ? void 0 : ctx.req) === null || _a === void 0 ? void 0 : _a.url.includes(u)); })) {
                            cache.delete(cacheKey);
                        }
                        return Promise.reject(err);
                    })
                        .finally(function () {
                        if (timeout2ThrowResult.timer)
                            clearTimeout(timeout2ThrowResult.timer);
                    }))];
            });
        }); });
        return promiseToReturn;
    }
    /**
     * process to handle cache result
     */
    return (processGlobalRequestInterceptors(ctx)
        .then(function (context) { return processInstanceRequestInterceptors(context); })
        .then(function () { return cachePromise; })
        // globally interceptors runs synchronously
        // .then((res) => {
        // do we want to run globally interceptors for cache result?
        // processGlobalResponseInterceptors(res, ctx)
        //   return res;
        // })
        // instance interceptors runs asynchronously
        .then(function (res) {
        ctx.operations.createResponseError = function (text, data) {
            return new ResponseError(res, text, data, ctx.req);
        };
        return processInstanceResponseInterceptors(res, ctx);
    })
        .then(function (res) {
        ctx.res = res;
        return next();
    })
        .catch(function (err) {
        return Promise.reject(err);
    }));
}

function parseResponse(ctx, next) {
    var resCopy;
    return next()
        .then(function () {
        if (!ctx)
            return Promise.resolve();
        var _a = ctx.res, res = _a === void 0 ? {} : _a, _b = ctx.req, req = _b === void 0 ? {} : _b;
        resCopy =
            (getEnv() === "BROWSER" && typeof res.clone === "function"
                ? res.clone()
                : res) || {};
        resCopy.useCache = res.useCache || false;
        var _c = req.options, _d = _c === void 0 ? {} : _c, _e = _d.responseType, responseType = _e === void 0 ? "json" : _e;
        if (responseType === "json") {
            return res.text().then(function (data) {
                try {
                    return JSON.parse(data);
                }
                catch (err) {
                    return data;
                }
            });
        }
        try {
            // 其他如text, blob, arrayBuffer, formData
            // @ts-ignore: we're catching error if responseType is not supported
            return res[responseType]();
        }
        catch (e) {
            throw new ResponseError(resCopy, "responseType not support", null, req, "ParseError");
        }
    })
        .then(function (body) {
        var _a;
        var _b = ctx.req, req = _b === void 0 ? {} : _b;
        var _c = req.options, _d = _c === void 0 ? {} : _c, cacheType = _d.cacheType, ttl = _d.ttl, _e = _d.validateStatus, validateStatus = _e === void 0 ? function (status) { return status >= 200 && status < 300; } : _e;
        if (!resCopy) {
            return;
        }
        if (validateStatus(resCopy.status)) {
            // 持久化
            if (cacheType === "persist") {
                try {
                    (_a = ctx === null || ctx === void 0 ? void 0 : ctx.storage) === null || _a === void 0 ? void 0 : _a.set(ctx.cacheKey, { data: body }, ttl);
                    // eslint-disable-next-line no-empty
                }
                catch (e) { }
            }
            ctx.finalResult = { data: body, response: resCopy };
            return;
        }
        throw new ResponseError(resCopy, "http error", body, req, "HttpError");
    })
        .catch(function (e) {
        if (e instanceof RequestError || e instanceof ResponseError) {
            throw e;
        }
        // 对未知错误进行处理
        var req = ctx.req, res = ctx.res;
        e.request = e.request || req;
        e.response = e.response || res;
        e.type = e.type || e.name;
        e.data = e.data || undefined;
        throw e;
    });
}

function getMiddleware(ctx, next) {
    if (!ctx)
        return next();
    var _a = ctx.req, _b = _a === void 0 ? {} : _a, _c = _b.options, options = _c === void 0 ? {} : _c, _d = _b.url, url = _d === void 0 ? "" : _d;
    var params = options.params;
    // 将 method 改为大写
    // @ts-ignore: ignore readonly
    options.method = options.method ? options.method.toUpperCase() : "GET";
    // 设置 credentials 默认值为 same-origin，确保当开发者没有设置时，各浏览器对请求是否发送 cookies 保持一致的行为
    // - omit: 从不发送cookies.
    // - same-origin: 只有当URL与响应脚本同源才发送 cookies、 HTTP Basic authentication 等验证信息.(浏览器默认值,在旧版本浏览器，例如safari 11依旧是omit，safari 12已更改)
    // - include: 不论是不是跨域的请求,总是发送请求资源域在本地的 cookies、 HTTP Basic authentication 等验证信息.
    // @ts-ignore: ignore readonly
    options.credentials = options.credentials || "same-origin";
    if (params) {
        ctx.req.originUrl = url;
        ctx.req.url = Object.entries(params).reduce(function (concatenatedUrl, _a) {
            var key = _a[0], value = _a[1];
            var param = "".concat(key, "=").concat(value);
            return concatenatedUrl.indexOf("?") > -1
                ? "".concat(concatenatedUrl, "&").concat(param)
                : "".concat(concatenatedUrl, "?").concat(param);
        }, url);
    }
    ctx.req.options = options;
    return next();
}

function postMiddleware(ctx, next) {
    if (!ctx)
        return next();
    var _a = ctx.req, _b = _a === void 0 ? {} : _a, _c = _b.options, options = _c === void 0 ? {} : _c;
    var _d = options.method, method = _d === void 0 ? "get" : _d;
    if (!["post", "put", "patch", "delete"].includes(method.toLowerCase()))
        return next();
    var _e = options.requestType, requestType = _e === void 0 ? "json" : _e, data = options.data;
    if (data) {
        var dataType = Object.prototype.toString.call(data);
        if (dataType === "[object Object]" || dataType === "[object Array]") {
            if (requestType === "json") {
                // @ts-ignore: ignore readonly
                options.headers = __assign({ Accept: "application/json", "Content-Type": "application/json;charset=UTF-8" }, options.headers);
                // @ts-ignore: ignore readonly
                options.body = JSON.stringify(data);
            }
        }
        else {
            // 其他 requestType 自定义header
            // @ts-ignore: ignore readonly
            options.headers = __assign({ Accept: "application/json" }, options.headers);
            // @ts-ignore: ignore readonly
            options.body = data;
        }
    }
    ctx.req.options = options;
    return next();
}

/**
 * Fetch class used to create new fetch instance
 *
 * @author Quincy Le
 * @class
 */
var Fetch = /** @class */ (function () {
    function Fetch(defaultConfig, settings) {
        if (defaultConfig === void 0) { defaultConfig = {}; }
        if (settings === void 0) { settings = {}; }
        this.defaultOpts = defaultConfig;
        this.cache = settings.cache;
        this.storage = settings.storage;
        this.interceptors = {
            globalRequestMap: settings.requestInterceptors || {},
            globalResponseMap: settings.responseInterceptors || {},
            instanceRequest: settings.instanceRequestInterceptors || [],
            instanceResponse: settings.instanceResponseInterceptors || [],
        };
        // Onion 中间件
        this.onion = new Onion();
        this.onion.use(postMiddleware);
        this.onion.use(getMiddleware);
        this.onion.use(parseResponse);
        this.onion.use(fetchMiddleware);
    }
    Fetch.prototype.get = function (url, opts) {
        if (opts === void 0) { opts = {}; }
        return this.fetch(url, __assign(__assign({}, opts), { method: "get" }));
    };
    Fetch.prototype.post = function (url, opts) {
        if (opts === void 0) { opts = {}; }
        return this.fetch(url, __assign(__assign({}, opts), { method: "post" }));
    };
    Fetch.prototype.delete = function (url, opts) {
        if (opts === void 0) { opts = {}; }
        return this.fetch(url, __assign(__assign({}, opts), { method: "delete" }));
    };
    Fetch.prototype.put = function (url, opts) {
        if (opts === void 0) { opts = {}; }
        return this.fetch(url, __assign(__assign({}, opts), { method: "put" }));
    };
    Fetch.prototype.patch = function (url, opts) {
        if (opts === void 0) { opts = {}; }
        return this.fetch(url, __assign(__assign({}, opts), { method: "patch" }));
    };
    Fetch.prototype.fetch = function (url, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        var opts = __assign(__assign(__assign({}, this.defaultOpts), options), { headers: __assign(__assign({}, this.defaultOpts.headers), options.headers) });
        var data = options.data, params = options.params, method = options.method, rewriteCacheKey = options.rewriteCacheKey;
        var cachePath = rewriteCacheKey ? rewriteCacheKey(url) : url;
        var cacheKey = JSON.stringify({
            url: cachePath,
            params: params,
            method: method,
            data: data,
        });
        var ctx = {
            req: {
                url: url,
                options: opts,
            },
            res: null,
            cache: this.cache,
            storage: this.storage,
            cacheKey: cacheKey,
            interceptors: this.interceptors,
            operations: {
                clearCache: function () {
                    return clearCache(_this.cache);
                },
                clearOneCache: function () {
                    return _this.cache.clearOneCache(cacheKey);
                },
                clearStorage: function () {
                    return _this.storage.delete(cacheKey);
                },
            },
        };
        return new Promise(function (resolve, reject) {
            if (options === null || options === void 0 ? void 0 : options.useCache) {
                if ((options === null || options === void 0 ? void 0 : options.cacheType) === "persist" && _this.storage.get(cacheKey)) {
                    var result = _this.storage.get(cacheKey);
                    resolve(result);
                    return;
                }
            }
            _this.onion
                .execute(ctx)
                .then(function () { return resolve(ctx.finalResult); })
                .catch(function (err) {
                var errorHandler = ctx.req.options.errorHandler;
                if (errorHandler) {
                    try {
                        var data_1 = errorHandler(err);
                        resolve(data_1);
                    }
                    catch (e) {
                        reject(e);
                    }
                }
                reject(err);
            });
        });
    };
    return Fetch;
}());

var DEFAULT_STORAGE_TTL = 1000 * 60;
var DEFAULT_MAX_SOTRAGE_SIZE = 4.5 * 1024 * 1024;
var ApiStorage = /** @class */ (function () {
    function ApiStorage() {
        var _this = this;
        /**
         * 最大 size
         *
         * @memberof ApiStorage
         */
        this.max_cache_size = DEFAULT_MAX_SOTRAGE_SIZE;
        /**
         * 获取缓存
         * 1. ttl 优先返回
         * 2. 5xx 100006 降级返回
         *
         * @param {string} cacheKey
         * @memberof ApiStorage
         */
        this.get = function (cacheKey) {
            if (window.localStorage) {
                try {
                    var value = localStorage.getItem(cacheKey) || "{}";
                    var _a = JSON.parse(value), expireAt = _a.expireAt, data = _a.data;
                    if (!data) {
                        return null;
                    }
                    var now = Date.now();
                    if (now <= expireAt) {
                        return data;
                    }
                    _this.delete(cacheKey);
                    return null;
                }
                catch (err) {
                    return null;
                }
            }
            return null;
        };
        /**
         * 删除
         *
         * @param {string} cacheKey
         * @memberof ApiStorage
         */
        this.delete = function (cacheKey) {
            if (window.localStorage) {
                localStorage.removeItem(cacheKey);
            }
        };
    }
    /**
     * 是否超过localstorage size
     *
     * @return {*}
     * @memberof ApiStorage
     */
    ApiStorage.prototype.isOverflowSize = function () {
        var _a;
        try {
            var total = 0;
            for (var i = 0; i < localStorage.length; i += 1) {
                var key = (_a = localStorage.key(i)) !== null && _a !== void 0 ? _a : "";
                if (key) {
                    var value = localStorage.getItem(key) || "";
                    total += key.length + value.length;
                }
            }
            return total > this.max_cache_size;
        }
        catch (error) {
            return false;
        }
    };
    /**
     * 设置缓存
     *
     * @param {string} cacheKey
     * @param {object} value
     * @param {*} [ttl=DEFAULT_STORAGE_TTL]
     * @return {*}
     * @memberof ApiStorage
     */
    ApiStorage.prototype.set = function (cacheKey, value, ttl) {
        if (ttl === void 0) { ttl = DEFAULT_STORAGE_TTL; }
        try {
            if (this.isOverflowSize() || !window.localStorage) {
                return;
            }
            var now = Date.now();
            localStorage.setItem(cacheKey, JSON.stringify({
                expireAt: now + ttl,
                data: value,
            }));
        }
        catch (error) { }
    };
    return ApiStorage;
}());

var SharedUniRequest = /** @class */ (function () {
    function SharedUniRequest(defaultConfig) {
        this.instanceRequestInterceptors = [];
        this.instanceResponseInterceptors = [];
        // 防止初始化的时候传入rewriteCacheKey 并设置方法调用时的参数，会导致所有cacheKey都被重写
        if (defaultConfig && defaultConfig.rewriteCacheKey)
            delete defaultConfig.rewriteCacheKey;
        this.fetch = new Fetch(defaultConfig, {
            cache: SharedUniRequest.cache,
            storage: SharedUniRequest.storage,
            requestInterceptors: SharedUniRequest.requestInterceptors,
            responseInterceptors: SharedUniRequest.responseInterceptors,
            instanceRequestInterceptors: this.instanceRequestInterceptors,
            instanceResponseInterceptors: this.instanceResponseInterceptors,
        });
    }
    SharedUniRequest.addGlobalRequestInterceptors = function (interceptorMap) {
        Object.entries(interceptorMap).forEach(function (_a) {
            var url = _a[0], handlers = _a[1];
            if (!Array.isArray(SharedUniRequest.requestInterceptors[url])) {
                SharedUniRequest.requestInterceptors[url] = [];
            }
            handlers.forEach(function (handler) {
                return SharedUniRequest.requestInterceptors[url].push(handler);
            });
        });
    };
    SharedUniRequest.addGlobalResponseInterceptors = function (interceptorMap) {
        Object.entries(interceptorMap).forEach(function (_a) {
            var url = _a[0], handlers = _a[1];
            if (!Array.isArray(SharedUniRequest.responseInterceptors[url])) {
                SharedUniRequest.responseInterceptors[url] = [];
            }
            handlers.forEach(function (handler) {
                return SharedUniRequest.responseInterceptors[url].push(handler);
            });
        });
    };
    SharedUniRequest.prototype.addInstanceRequestInterceptors = function (interceptors) {
        var _this = this;
        interceptors.forEach(function (i) { return _this.instanceRequestInterceptors.push(i); });
    };
    SharedUniRequest.prototype.addInstanceResponseInterceptors = function (interceptors) {
        var _this = this;
        interceptors.forEach(function (i) { return _this.instanceResponseInterceptors.push(i); });
    };
    SharedUniRequest.prototype.request = function (url, opts) {
        if (opts === void 0) { opts = {}; }
        return this.fetch.get(url, opts);
    };
    SharedUniRequest.prototype.get = function (url, opts) {
        if (opts === void 0) { opts = {}; }
        return this.fetch.get(url, opts);
    };
    SharedUniRequest.prototype.post = function (url, opts) {
        if (opts === void 0) { opts = {}; }
        return this.fetch.post(url, opts);
    };
    SharedUniRequest.prototype.patch = function (url, opts) {
        if (opts === void 0) { opts = {}; }
        return this.fetch.patch(url, opts);
    };
    SharedUniRequest.prototype.put = function (url, opts) {
        if (opts === void 0) { opts = {}; }
        return this.fetch.put(url, opts);
    };
    SharedUniRequest.prototype.delete = function (url, opts) {
        if (opts === void 0) { opts = {}; }
        return this.fetch.delete(url, opts);
    };
    SharedUniRequest.prototype.freezeCacheDeletion = function (urlToFreeze) {
        if (urlToFreeze === void 0) { urlToFreeze = {}; }
        this.fetch.cache.freezeCacheDeletion(urlToFreeze);
    };
    SharedUniRequest.storage = new ApiStorage();
    SharedUniRequest.cache = new Cache();
    SharedUniRequest.version = "2.0.0";
    SharedUniRequest.requestInterceptors = {};
    SharedUniRequest.responseInterceptors = {};
    SharedUniRequest.getGlobalSharableEntry = function () {
        var version = getMajorVersion(SharedUniRequest.version);
        return getGlobal().SharedUniRequest[version];
    };
    return SharedUniRequest;
}());
function getGlobal() {
    /* eslint-disable no-restricted-globals */
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof global !== "undefined") {
        return global;
    }
    throw new Error("unable to locate global object");
}
function getMajorVersion(version) {
    return version.split(".")[0] || "0";
}
var version = getMajorVersion(SharedUniRequest.version);
var globalContext = getGlobal();
if (!globalContext.SharedUniRequest)
    globalContext.SharedUniRequest = {};
if (!globalContext.SharedUniRequest[version]) {
    globalContext.SharedUniRequest[version] = {
        cache: new Cache(),
        requestInterceptors: {},
        responseInterceptors: {},
    };
}
SharedUniRequest.cache = globalContext.SharedUniRequest[version].cache;
SharedUniRequest.requestInterceptors =
    globalContext.SharedUniRequest[version].requestInterceptors;
SharedUniRequest.responseInterceptors =
    globalContext.SharedUniRequest[version].responseInterceptors;

export { SharedUniRequest as UniRequest };
